// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js","379":"1bfc9850"}[chunkId] || chunkId) + "-" + {"125":"bd49c6f4069f796a3200","223":"cca32a196c8a28e630d8","293":"8f42214509ba6cecca9e","379":"6b006672e4f8dff994bb","518":"ad8d683e2bbabeb13d6c"}[chunkId] + ".js";
};